<script>
export default {
  name: 'NumberRangeInput',
  components: {},
  props: {
    min: {
      type: [Number, String],
      default: null,
    },
    max: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      minValue: this.min,
      maxValue: this.max,
    };
  },
  computed: {
    
  },
  watch: {
    min(val) {
      if (val !== this.minValue) {
        this.minValue = val;
      }
    },
    max(val) {
      if (val !== this.maxValue) {
        this.maxValue = val;
      }
    },
    minValue(val) {
      if (val !== this.min) {
        this.$emit('update:min', val);
      }
    },
    maxValue(val) {
      if (val !== this.max) {
        this.$emit('update:max', val);
      }
    },
  },
  mounted() {
    
  },
  methods: {
    onChange() {
      this.$emit('change');
    },
  }
}
</script>

<template>
  <div class="flex flex-direction gap-sm padding-sm">
    <div>
      <span>最小：</span>
      <vxe-number-input
        v-model="minValue"
        :placeholder="$t('general.placeholder.enter.search')"
        type="integer"
        :control-config="{
          enabled: false,
        }"
        @change="onChange"
      ></vxe-number-input>
    </div>
    <div>
      <span>最大：</span>
      <vxe-number-input
        v-model="maxValue"
        :placeholder="$t('general.placeholder.enter.search')"
        type="integer"
        :control-config="{
          enabled: false,
        }"
        @change="onChange"
      ></vxe-number-input>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>